import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';

import { config } from '../success-stories-banner.settings';
import GalleryItem from '../gallery-item';

import styles from './models-gallery.module.scss';

const ModelsGallery: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const { models } = config;
  const containerRef = React.useRef<HTMLDivElement>(undefined);
  const sliderRef = React.useRef<HTMLDivElement>(undefined);

  // The slider needs to be centered if it's narrower than the viewport
  const setInitialSliderPosition = React.useCallback(() => {
    if (!containerRef.current || !sliderRef.current) {
      return;
    }

    if (containerRef.current.clientWidth > sliderRef.current.offsetWidth) {
      sliderRef.current.style.left = `${(containerRef.current.clientWidth - sliderRef.current.offsetWidth) / 2}px`;

      return;
    }

    sliderRef.current.style.left = '0';
  }, [containerRef, sliderRef]);

  // We need to determine slider position after first layout and paint, hence the timeout
  setTimeout(setInitialSliderPosition, 500);

  return (
    <Html.div className={[styles.modelsGallery, 'w-100']}>
      <Html.div className={styles.container} ref={containerRef}>
        <Html.div className={styles.slider} ref={sliderRef}>
          {models.map((model) => {
            return (
              <GalleryItem
                key={model.name}
                image={model.image}
                name={model.name}
                quote={formatMessage(model.quote)}
                link={model.link}
              />
            );
          })}
        </Html.div>
      </Html.div>
    </Html.div>
  );
};

export default ModelsGallery;
